const messagesEllipse = (text = '') => {
  if (text?.length > 120) {
    text = `${text?.substring(0, 120)} ...`;
  } else if (text?.length === 0) {
    text = 'N/A';
  }
  return text;
};
export default messagesEllipse;
